import { AppStateInterface } from '../state/app.state';
import { createSelector } from '@ngrx/store';
import { ExpertStoreInterface } from '../models/expert-store.interface';

export const selectExpert = (state: AppStateInterface) => state.expert;

export const expertSelector = createSelector(selectExpert, (state: ExpertStoreInterface) => state);

export const expertNameSelector = createSelector(
  selectExpert,
  (state: ExpertStoreInterface) => state.name,
);

export const expertIsTypingSelector = createSelector(
  selectExpert,
  (state: ExpertStoreInterface) => state.isTyping,
);

export const expertImgSelector = createSelector(
  selectExpert,
  (state: ExpertStoreInterface) => state.img,
);
